import React, { Component } from 'react'
import injectSheet from 'react-jss'
import styles from './assessment.styles'
import ContentHolder from '../../../content-holder/content-holder'
import Paper from 'pobble-components/dist/paper'
import AssessmentsTable from './assessments-table/assessments-table.container'
import AssessmentSkeleton from './assessment-skeleton/assessment-skeleton'
import AssessementInvitationModal from './assessment-invitation-modal/assessment-invitation-modal.container'

class Assessment extends Component {
  componentDidMount() {
    this.props.onMount()
  }
  render() {
    const { classes, pending } = this.props
    return (
      <ContentHolder>
        <Paper className={classes.paper}>
          {pending && <AssessmentSkeleton />}
          {!pending && <AssessmentsTable />}
        </Paper>
        <AssessementInvitationModal />
      </ContentHolder>
    )
  }
}

export default injectSheet(styles)(Assessment)
